import { usePage } from '@inertiajs/react';
import { Home } from 'lucide-react';
import { useMemo } from 'react';
import NexusNavLink from '../navigation/NexusNavLink';
import { buildBreadcrumbs, normalizePath } from '../../lib/menuPath';
import type { PageProps } from '../../types';

type NexusBreadcrumbProps = {
    pageTitle?: string | null;
};

export default function NexusBreadcrumb({ pageTitle }: NexusBreadcrumbProps) {
    const { url, props } = usePage<PageProps>();
    const menu = props.menu ?? [];
    const path = normalizePath(url);

    const crumbs = useMemo(
        () =>
            buildBreadcrumbs({
                menu,
                path,
                pageTitle,
            }),
        [menu, path, pageTitle],
    );

    if (crumbs.length === 0) {
        return null;
    }

    return (
        <nav className="nx-breadcrumb" aria-label="Navegação estrutural">
            <Home
                className="nx-breadcrumb-home"
                size={15}
                strokeWidth={1.9}
                aria-hidden
            />
            <ol className="nx-breadcrumb-list">
                {crumbs.map((crumb, index) => {
                    const isLast = index === crumbs.length - 1;

                    return (
                        <li key={`${crumb.label}-${index}`} className="nx-breadcrumb-item">
                            {index > 0 && (
                                <span className="nx-breadcrumb-sep" aria-hidden>
                                    &gt;
                                </span>
                            )}
                            {isLast || !crumb.href ? (
                                <span
                                    className={
                                        isLast
                                            ? 'nx-breadcrumb-current'
                                            : 'nx-breadcrumb-text'
                                    }
                                    aria-current={isLast ? 'page' : undefined}
                                >
                                    {crumb.label}
                                </span>
                            ) : (
                                <NexusNavLink
                                    href={crumb.href}
                                    className="nx-breadcrumb-link"
                                    preserveScroll
                                >
                                    {crumb.label}
                                </NexusNavLink>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}
